var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',{attrs:{"icon":"clock","title":"History"}},[(_vm.history.length)?_c('History',{attrs:{"items":_vm.history}}):_vm._e(),(!_vm.history.length)?_c('span',[_vm._v("No history items to show")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }